import { FC } from "react";
import { Divider, List, Stack, Typography } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import {
  AccountBoxOutlined,
  BusinessCenterOutlined,
  FilterAltOutlined,
  LockOutlined,
  NotificationsNoneOutlined,
  Payment,
  PeopleAltOutlined,
  VpnKeyOutlined,
} from "@mui/icons-material";
import { useFlag } from "@unleash/proxy-client-react";
import { NavItem } from "../nav-item/NavItem";
import { useAppAbility } from "../../../../services/permissions";
import { SettingsNavigationLogoutButton } from "../../../pages/settings/components/SettingsNavigationLogoutButton";

interface SettingsNavigationListItemsProps {
  disabled: boolean;
}

export const SettingsNavigationListItems: FC<
  SettingsNavigationListItemsProps
> = ({ disabled }) => {
  const { can } = useAppAbility();
  const enableEmailPreferencesSettings = useFlag(
    "EnableEmailPreferencesSettings",
  );
  const enableDimensions = useFlag("EnableDimensions");

  return (
    <Stack justifyContent="space-between" flexGrow={1}>
      <div>
        <List
          dense
          disablePadding
          subheader={
            <Typography variant="overline" pl={1} gutterBottom={false}>
              PREFERENCES
            </Typography>
          }
        >
          {enableDimensions ? (
            <NavItem
              primary="Dimensions"
              to="/settings/dimensions"
              icon={ListIcon}
            />
          ) : (
            <NavItem
              primary="Categories"
              to="/settings/categories"
              icon={ListIcon}
            />
          )}

          <NavItem
            primary="Smart Tag"
            to="/settings/smart-tag"
            icon={FilterAltOutlined}
          />
        </List>

        <Divider sx={{ my: 1 }} />

        <List
          dense
          disablePadding
          subheader={
            <Typography variant="overline" pl={1} gutterBottom={false}>
              ORGANIZATION
            </Typography>
          }
        >
          <NavItem
            to="/settings/users"
            primary="Users"
            icon={PeopleAltOutlined}
            disabled={disabled}
          />

          <NavItem
            to="/settings/billing"
            primary="Plans & Billing"
            icon={Payment}
            disabled={disabled}
          />

          {can("edit", "organisation") && (
            <NavItem
              to="/settings/organization"
              primary="General"
              icon={BusinessCenterOutlined}
              disabled={disabled}
            />
          )}

          <NavItem
            to="/settings/api-keys"
            primary="API Keys"
            icon={VpnKeyOutlined}
            disabled={disabled}
          />
        </List>

        <Divider sx={{ my: 1 }} />

        <List
          dense
          disablePadding
          subheader={
            <Typography variant="overline" pl={1}>
              PROFILE
            </Typography>
          }
        >
          <NavItem
            to="/settings/profile"
            icon={AccountBoxOutlined}
            primary="Profile"
            disabled={disabled}
          />

          {enableEmailPreferencesSettings && (
            <NavItem
              to="/settings/notifications"
              icon={NotificationsNoneOutlined}
              primary="Email Notifications"
              disabled={disabled}
            />
          )}

          <NavItem
            to="/settings/auth"
            icon={LockOutlined}
            primary="Account Security"
            disabled={disabled}
          />
        </List>
      </div>

      <SettingsNavigationLogoutButton inPopover={false} />
    </Stack>
  );
};
